module.exports = __webpack_public_path__ + "files/618c705a48bb1fa1f5729611fd58739a.png";